import { Box, Flex, Heading, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import 'source/borrower/borrower.scss';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import CapitalProviderContextProvider from 'packages/organization/hooks/CapitalProviderContextProvider';
import { OutstandingLedgerViewContainer } from 'packages/statements/ui/OutstandingLedgerViewContainer';
import { StatementsTemplate } from 'packages/statements/ui/StatementsTemplate';

export const StatementsOutstandingLedgerRoute = () => {
  const toast = useToast();
  const history = useHistory();

  let routeLevelError = false;

  const { data: userData, loading: userLoading } = useGetUserQuery();
  const { creditFacilityId } = useCreditFacilityContext();

  if (!userData || userLoading) {
    return <Skeleton data-testid="loading-statements-view" height="600px" />;
  }
  const { user } = userData;

  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load outstanding balance route`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <Flex justify="space-between">
          <Heading as="h2">Statements</Heading>
          <Box>
            <CreditFacilitySelect organizationId={user?.organizationId} />
          </Box>
        </Flex>
        <StatementsTemplate selectedTab="outstanding-ledger">
          <CapitalProviderContextProvider renderLoading={<Skeleton />}>
            <OutstandingLedgerViewContainer
              creditFacilityId={creditFacilityId}
            />
          </CapitalProviderContextProvider>
        </StatementsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
